import { render, staticRenderFns } from "./addEquipmentList.vue?vue&type=template&id=489e104a&scoped=true&"
import script from "./addEquipmentList.vue?vue&type=script&lang=js&"
export * from "./addEquipmentList.vue?vue&type=script&lang=js&"
import style0 from "./addEquipmentList.vue?vue&type=style&index=0&id=489e104a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489e104a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('489e104a')) {
      api.createRecord('489e104a', component.options)
    } else {
      api.reload('489e104a', component.options)
    }
    module.hot.accept("./addEquipmentList.vue?vue&type=template&id=489e104a&scoped=true&", function () {
      api.rerender('489e104a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/constructionEquipmentMgr/stockMgr/mobile/components/addEquipmentList.vue"
export default component.exports